import Vue from 'vue';

/** Event bus for sending probes events. */
const ProbesEventBus = new Vue();

export default ProbesEventBus;
